<template>
	<div>
        <div class="bg-primary-4 text-p2  @md:py-3xs @md:gap-sm gap-2xs @md:flex-row @md:items-center flex select-none flex-col justify-between rounded-md mb-sm">
            <div class="@md:gap-3xs gap-2xs @md:flex-row @md:items-center flex flex-col items-start w-full justify-between">
                <div class="px-6xs flex items-center gap-1 rounded-sm py-[2px]">
                    <a 
                    class="whitespace-nowrap text-p2 flex h-[40px] items-center leading-none transition  cursor-pointer"
                    @click.prevent="openVideo(videos.english)"
                    >
                    <span class="text-quaternary relative">
                        Podcast: Beyond Selling - How Untrading is Fixing a Broken System
                    </span>
                    </a>
                </div>
                <div class="text-sm @md:ml-auto">
                    <p class="@md:text-right inline">
                        <a 
                        class="whitespace-nowrap text-p2 flex h-[40px] items-center !rounded-full leading-none transition  cursor-pointer"
                        @click.prevent="openVideo(videos.chinese)"
                        >
                        <span class="text-quaternary relative">
                            播客：退出即开始 - Untrading 如何终结 90% 交易者的亏损困境
                        </span>
                        </a>
                    </p>
                </div>
            </div>
        </div>
        
	 <!-- 视频弹窗模态框 - 只保留视频 -->
    <div 
      v-if="dialog" 
      class="fixed inset-0 z-50 flex items-center justify-center"
      @click.self="closeVideo"
    >
      <!-- 视频播放区域 -->
      <div class="relative w-full max-w-4xl mx-4" style="padding-bottom: 56.25%; /* 16:9 */">
        <iframe
          v-if="currentVideo.url"
          :src="currentVideo.url"
          class="absolute top-0 left-0 w-full h-full"
          frameborder="0"
          allowfullscreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        ></iframe>
        <iframe
    v-if="currentVideo.url"
    :src="currentVideo.url"
    class="absolute top-0 left-0 w-full h-full"
    allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
    allowfullscreen
  ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VideoLinksComponent',
  data() {
    return {
      dialog: false,
      currentVideo: {
        title: '',
        url: ''
      },
      videos: {
        english: {
          title: 'Beyond Selling - How Untrading is Fixing a Broken System',
          url: 'https://customer-cc44yfs1ng5d1ck2.cloudflarestream.com/f67478ee75621cda450a690003a29161/iframe?poster=https%3A%2F%2Fcustomer-cc44yfs1ng5d1ck2.cloudflarestream.com%2Ff67478ee75621cda450a690003a29161%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600'
        },
        chinese: {
          title: '退出即开始 - Untrading 如何终结 90% 交易者的亏损困境',
          url: 'https://customer-cc44yfs1ng5d1ck2.cloudflarestream.com/7fc1005c2515e4f4d49d700b9a333cdf/iframe?autoplay=true&poster=https%3A%2F%2Fcustomer-cc44yfs1ng5d1ck2.cloudflarestream.com%2F7fc1005c2515e4f4d49d700b9a333cdf%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600'
        }
      }
    }
  },
  methods: {
    openVideo(video) {
      this.currentVideo = { ...video }
      this.dialog = true
      // 防止页面滚动
      document.body.style.overflow = 'hidden'
    },
    closeVideo() {
      this.dialog = false
      // 恢复页面滚动
      document.body.style.overflow = 'auto'
      // 延迟清空视频URL，避免关闭时闪烁
      setTimeout(() => {
        this.currentVideo = { title: '', url: '' }
      }, 300)
    }
  },
  beforeUnmount() {
    // 组件销毁时恢复页面滚动
    document.body.style.overflow = 'auto'
  }
}
</script>

<style scoped>
/* 弹窗动画效果 */
.fixed {
  animation: fadeIn 0.3s ease-out;
}

.fixed > div {
  animation: slideIn 0.3s ease-out;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { 
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to { 
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

/* 响应式设计 */
@media (max-width: 640px) {
  .fixed > div {
    margin: 1rem;
    max-width: calc(100vw - 2rem);
  }
  
  .relative[style*="padding-bottom"] {
    padding-bottom: 75% !important; /* 移动端调整宽高比 */
  }
}

/* 确保Tailwind CSS类正常工作 */
@media (min-width: 768px) {
  .md\:min-h-\[96px\] {
    min-height: 96px;
  }
}

@media (min-width: 640px) {
  .sm\:max-w-\[545px\] {
    max-width: 545px;
  }
}
</style>